import { useLocation, useNavigate } from 'react-router-dom';
import logoCCBJI from "@/assets/img/2800_CCBJI_Logo.bmp";
import logoFVJ from "@/assets/img/2801_FVJ_Logo.bmp";
import { useEffect, useState } from 'react';
import NavbarPublic from '@/features/homepage/components/NavbarPublic';

// SCN08

const ResetPasswordInformPage = () => {
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const props = location.state || null;
    useEffect(() => {
        // If no props, user came here incorrectly, so redirect to login
        if (!props) {
            navigate('/login');
        } else if (props && props.showSuccessResetPasswordModal == true) {
            setShowSuccessModal(true)
        }
    }, [navigate, props]);

    // Handler to navigate back to login page
    const backToLogin = () => {
        navigate('/login');
    };

    // If success modal should not show, render nothing
    if (!showSuccessModal) {
        return <></>
    }

    // UI render
    return (
        <>
            <NavbarPublic
                logoCCBJI={logoCCBJI}
                logoFVJ={logoFVJ}
                backToLogin={backToLogin}
            />
            <div className="container-fluid background-cover-external">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item active">パスワードリセット完了</li>
                </ol>
                <div className="jumbotron">
                    <div className="section">
                        <div className="card-body" style={{ minHeight: '45vh' }}>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">
                                    <p>
                                        <span>パスワード再設定URLをご登録のメールアドレスに送信いたしました。</span> <br />
                                        <span>メールをご確認のうえ、記載されたリンクからパスワードの再設定をお願いいたします。</span> <br />
                                        <span>ご登録用URLの有効期間は、発行から24時間となっております。</span> <br />
                                        <span>期限を過ぎた場合は、再度お手続きいただく必要がございますので、あらかじめご了承ください。</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default ResetPasswordInformPage;
